import { render } from "./OfferIcon.vue?vue&type=template&id=31f68ce4"
import script from "./OfferIcon.vue?vue&type=script&lang=js"
export * from "./OfferIcon.vue?vue&type=script&lang=js"
script.render = render

export default script